import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import i18n from '@/libs/i18n/index'
import store from '@/store'
import useEntityCrud from '@/composable/useEntityCrud'
import { ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import useErrorManager from '@/composable/useErrorManager'

export default function useFAQsList() {
  function convertResource(resource, selectedLang) {
    return {
      ...resource,
      title: resource.title[selectedLang],
      question: resource.question[selectedLang],
      answer: resource.answer[selectedLang],
      keywords: resource.keywords[selectedLang],
      lang: selectedLang,
      user: resource.userId,
      writer: resource.writerId,
      editor: resource.editorId,
      category: resource.faqCategoryId ? { title: resource.faqCategoryId.title[selectedLang], _id: resource.faqCategoryId._id } : {},
    }
  }

  const MODULE_NAME = 'FAQs'
  const ENDPOINT = 'faq'
  const toast = useToast()
  const errorManager = useErrorManager()
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)
  const FAQCategories = ref([])

  // Table Handlers
  const tableColumns = [
    {
      key: 'title', label: i18n.t('general.title'), type: 'truncate-text', sortable: true,
    },
    { key: 'userId', label: i18n.t('general.creator'), type: 'user' },
    { key: 'question', label: i18n.t('FAQs.question'), type: 'truncate-text' },
    { key: 'category', label: i18n.t('general.category') },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), type: 'dateTime', sortable: true,
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), type: 'dateTime', sortable: true,
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  const fetchFAQCategories = lang => {
    store
      .dispatch('crud/fetchList', { queryParams: { lang }, endpoint: 'faq-categories' })
      .then(response => {
        FAQCategories.value = response.data.data.map(item => ({ _id: item._id, title: item.title[lang] }))
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('errors.errorFetchData'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  return {
    ...entity,
    errorManager,
    FAQCategories,
    convertResource,
    fetchFAQCategories,
    tableColumns,
  }
}
